export enum FetchedApprovalTypes {
  roles = 'roles',
  users = 'users',
  operation = 'operation',
}

export enum ApprovalItems {
  buyingPlan = 'buying_plan',
  channelMix = 'channel_mix',
}

export enum SingleModalWindowTabs {
  CC_AND_COMMENT = 'comment',
  SUMMARY = 'summary',
}

export enum MultiModalWindowTabs {
  CHOOSE_APPROVAL_FLOW = 'choose_approval_flow',
  CC_AND_COMMENT = 'comment',
}
